import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const Minivision: Dashboard = {
    id: 'MINIVISION',
    name: 'Minivision',
    daterange: true,
    metrics: [
        {
            type: Metrics.MINIVISION_DWELLTIMELINE,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            color: '#2f9b8f',
            title: 'dashboard-dwelltimeline',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.MINIVISION_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.MINIVISION_INTERACTIONS_GROUPED,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-interactions-grouped',
            count: 'dashboard-count-interactions',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.SIXTH,
            metrics: [
                {
                    type: Metrics.MINIVISION_INTERACTIONS,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-interactions',
                },
                {
                    type: Metrics.MINIVISION_SOUNDBARS_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-minivision-soundbars-top',
                },
            ],
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.SIXTH,
            metrics: [
                {
                    type: Metrics.MINIVISION_CONTENT_TOP,
                    'box-size': 'fullwidth',
                    title: 'dashboard-content-top',
                },
            ],
        },
    ],
}

export default Minivision
